module.exports = __webpack_public_path__ + "img/dashboard-main-bg-2.28829481.jpg";